import { Focus8WAPI } from "./MainClient";

var iRequestId = 1;

export function GlobalValues() {
  Focus8WAPI.getGlobalValue("cbFunction", "*", iRequestId++);
}

/* export function GettingHeaderFieldValues() {
  Focus8WAPI.getFieldValue(
    "gettingHeaderDetails",
    ["DocNo", "Date", "JobWorkRefNo"],
    Focus8WAPI.ENUMS.MODULE_TYPE.TRANSACTION,
    false,
    iRequestId++
  );
} */
